export default __webpack_public_path__ + "6c6f3185ea24da8e0e4bbe2720799298.svg";